import axios from "axios";
import { API_BASE_URL } from "../config/env";
import { store } from "../redux/store";
import { userActionCreators } from "../redux/user";

export const getTokenExpiryInSeconds = (token) => {
  try {
    if (!token) return 0;

    const payload = token.split(".")[1];
    if (!payload) return 0;

    const normalizedPayload = payload
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(payload.length + ((4 - (payload.length % 4)) % 4), "=");

    const decodedPayload = JSON.parse(atob(normalizedPayload));
    return Number(decodedPayload.exp || 0);
  } catch (error) {
    return 0;
  }
};

export const shouldRefreshToken = (token, bufferSeconds = 300) => {
  if (!token) return false;

  const expiry = getTokenExpiryInSeconds(token);
  if (!expiry) return false;

  const nowInSeconds = Math.floor(Date.now() / 1000);
  return expiry - nowInSeconds <= bufferSeconds;
};

const handleExpiredSession = () => {
  localStorage.removeItem("token");

  try {
    store.dispatch(userActionCreators.logout());
  } catch (error) {
    // no-op if the store is not ready yet
  }

  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

export const refreshTokenIfNeeded = async (token) => {
  if (!token || !shouldRefreshToken(token)) {
    return token;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}user/refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (response?.data?.status === "ok" && response?.data?.token) {
      localStorage.setItem("token", response.data.token);
      return response.data.token;
    }
  } catch (error) {
    // ignored, handled below
    handleExpiredSession();
  }

  // handleExpiredSession();
  return null;
};

const attachToken = async (config) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return config;
  }

  const validToken = await refreshTokenIfNeeded(token);
  if (validToken) {
    config.headers.Authorization = `Bearer ${validToken}`;
  }

  return config;
};

// const resolveError = (error) => {
//   return Promise.reject(error);
// };

const resolveError = (error) => {
  return Promise.reject(error);
};

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(attachToken, resolveError);

const api = {};
export default api;
